export const CRUD_ACTION_TYPE = {
  NUOVO: 1,
  MODIFICA: 2,
  COPIA: 3,
};
